<template>
  <div class="container">
    <h3>修改手机号-邮箱认证</h3>
    <div class="tip">认证邮件已发往您的邮箱，请您在一小时内完成认证！</div>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="验证码" prop="captch">
        <el-input v-model="form.captch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">提交认证</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    return {
      email: "",
      form: {
        captch: ""
      },
      rules: {
        captch: [{ required: true, message: "请输入验证码", trigger: "change" }]
      }
    };
  },
  methods: {
    getCode() {
      _api.personal.getCode({ code_type: "2", value: this.email }).then(res => {
        this.sendStatus = true;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          _api.personal
            .checkCode({ code: this.form.captch, code_type: 2 })
            .then(res => {
              if (res.data == 2) {
                this.$message({
                  message: "验证码错误",
                  type: "error"
                });
              } else if (res.data == 3) {
                this.$message({
                  message: "验证码已失效",
                  type: "error"
                });
              } else {
                this.$message({
                  message: "验证成功",
                  type: "success"
                });
                this.$router.push({
                  path: "/modifyTel/tel-bind",
                  query: { code: this.form.captch,type:2 }
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {
    this.email = this.$store.getters.userInfo.email;
    this.getCode();
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    margin: 30px 0 15px;
  }
  .tip {
    margin: 20px 0 30px;
    font-size: 14px;
  }
  button {
    width: 120px;
    height: 36px;
    font-size: 12px;
  }
}
</style>
